export function isDeletedUser(user: any): boolean {
  if (!user) return false;
  return user.isDeletedUser === true || user.status === "deleted";
}

export function getDisplayName(user: { preferredName?: string | null; firstName?: string | null; lastName?: string | null; isDeletedUser?: boolean; status?: string | null } | null | undefined): string {
  if (!user) return "Traveler";
  if (isDeletedUser(user)) return "Deleted User";
  if (user.preferredName) return user.preferredName;
  const full = [user.firstName, user.lastName].filter(Boolean).join(" ");
  return full || "Traveler";
}

export function getInitials(user: { preferredName?: string | null; firstName?: string | null; lastName?: string | null; isDeletedUser?: boolean; status?: string | null } | null | undefined): string {
  if (!user) return "?";
  if (isDeletedUser(user)) return "DU";
  if (user.preferredName) {
    return user.preferredName.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase() || "?";
  }
  const fi = (user.firstName || "")[0] || "";
  const li = (user.lastName || "")[0] || "";
  return (fi + li).toUpperCase() || "?";
}
